import React from 'react'
import Label from 'LuxKit/Label'

interface Props {
  offer: App.MerchandiseOffer
}

function MerchandiseFreeShippingLabel({ offer }: Props) {
  if (!offer.hasFreeShipping) {
    return null
  }

  return <Label kind="tertiary" variant="highlight">
    Free shipping
  </Label>
}

export default MerchandiseFreeShippingLabel
